import SegmentBasedInplayScoreboard from 'presentation/components/scoreboard/segment-based-inplay-scoreboard/index.js';
import MojitoCore from 'mojito/core';
import { range } from 'mojito/utils';
import * as utils from '../utils.js';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const HT_CODE = '_ht_result';

export default class PeriodBasedInplayScoreboard extends UIViewImplementation {
    getPeriodName(periodNumber, periodCount, maxSegments) {
        const { sportId } = this.props.event;
        let name;
        if (periodNumber <= maxSegments) {
            name = utils.getSegmentName(periodNumber, sportId, 'DEFAULT_PERIOD', this.l10n);
        } else {
            // Show no overtime number if there is only single overtime
            const overtimeNumber =
                periodCount > maxSegments + 1 ? periodNumber - maxSegments : undefined;
            name = utils.getOvertimeName(overtimeNumber, 'DEFAULT_OVERTIME', this.l10n);
        }
        return name;
    }

    getTotalScoreString() {
        const { sportId } = this.props.event;
        const systemSettings = this.appContext().systemSettings();
        return utils.getTotalScoreString(sportId, systemSettings, this.l10n);
    }

    getSumPeriod(periods, n) {
        return periods
            .slice(0, n)
            .map(period => period.scores)
            .reduce(
                (accumulator, currentValue) => {
                    return [
                        parseInt(accumulator[0], 10) + parseInt(currentValue[0], 10),
                        parseInt(accumulator[1], 10) + parseInt(currentValue[1], 10),
                    ];
                },
                [0, 0]
            );
    }

    getHalfTimePeriodScores(periods, currentPeriod, selected) {
        const PERIOD_BEFORE_HALFTIME = 2;
        if (currentPeriod > PERIOD_BEFORE_HALFTIME || selected) {
            return this.getSumPeriod(periods, PERIOD_BEFORE_HALFTIME);
        }
        const emptyScore = this.resolveString('$PERIOD_BASED_INPLAY_SCOREBOARD.EMPTY_SCORE');
        return [emptyScore, emptyScore];
    }

    getHalfTimePeriod(periods, currentPeriod, inplayDescription) {
        const selected = inplayDescription === HT_CODE;
        const scores = this.getHalfTimePeriodScores(periods, currentPeriod, selected);

        return {
            header: this.resolveString('$PERIOD_BASED_INPLAY_SCOREBOARD.HALFTIME'),
            scores,
            selected,
        };
    }

    getPeriodsWithHalfTime(periods, currentNumberOfSegments) {
        const { event } = this.props;
        const { listOfSportsWithHalfTime } = this.config;

        if (listOfSportsWithHalfTime.indexOf(event.sportId) !== -1) {
            const halfTime = this.getHalfTimePeriod(
                periods,
                currentNumberOfSegments,
                event.details.inplayDescription
            );
            periods.splice(2, 0, halfTime);

            if (halfTime.selected) {
                periods[1].selected = false;
            }
        }

        return periods;
    }

    getMappedPeriods() {
        const { event } = this.props;
        const participantsPosition = utils.getParticipantsPosition(event);
        const maxSegments = this.config.numberOfPeriods[event.sportId]
            ? this.config.numberOfPeriods[event.sportId]
            : this.config.numberOfPeriods.default;
        const currentNumberOfSegments = event.details.detailedScores.length;
        const numberOfSegments =
            currentNumberOfSegments > maxSegments ? currentNumberOfSegments : maxSegments;
        const columns = range(numberOfSegments);
        const emptyScore = this.resolveString('$PERIOD_BASED_INPLAY_SCOREBOARD.EMPTY_SCORE');

        const periods = columns.map((x, i) => {
            const segmentScores = event.details.detailedScores[i] || {};
            const scores = [
                segmentScores[participantsPosition[0]] || emptyScore,
                segmentScores[participantsPosition[1]] || emptyScore,
            ];
            const index = i + 1;
            const selected = index === event.details.segmentNumber;

            return {
                header: this.getPeriodName(index, columns.length, maxSegments),
                scores,
                selected,
            };
        });

        const periodsWithHalfTime = this.getPeriodsWithHalfTime(periods, currentNumberOfSegments);

        return periodsWithHalfTime;
    }

    getDetailedParticipantsData() {
        const { event } = this.props;
        return utils.getDetailedParticipantsData(event, 'totalScores');
    }

    render() {
        const { event, inplayTime, hasClockDetails } = this.props;

        if (!event || !event.details) {
            return null;
        }

        const detailedSegments = this.getMappedPeriods();
        const displayStrings = {
            totalScore: this.getTotalScoreString(),
        };

        return (
            <SegmentBasedInplayScoreboard
                config={this.config.segmentBasedInplayScoreboard}
                event={event}
                detailedParticipantsData={this.getDetailedParticipantsData()}
                hasServer={!!event.details.server}
                detailedSegments={detailedSegments}
                displayStrings={displayStrings}
                inplayTime={inplayTime}
                hasClockDetails={hasClockDetails}
            />
        );
    }
}
